import Rect from "../api/model/snapshots/layers/Rect";

interface Point {
    x: number;
    y: number;
}

interface RectContainsPointOptions {
    discardHorizontalPosition?: boolean;
    discardVerticalPosition?: boolean;
    endsInclusive?: boolean;
}

/**
 * Checks whether the rect covers the otherRect area-wise.
 * */
function rectContains(rect: Rect, otherRect: Rect): boolean {
    const rectX2 = rect.x + rect.width;
    const rectY2 = rect.y + rect.height;
    const otherRectX2 = otherRect.x + otherRect.width;
    const otherRectY2 = otherRect.y + otherRect.height;

    return rect.x <= otherRect.x && rect.y <= otherRect.y &&
        rectX2 >= otherRectX2 && rectY2 >= otherRectY2;
}

function rectContainsPoint(rect: DOMRect | Rect, point: Point, options: RectContainsPointOptions = {}): boolean {
    let left;
    let right;
    let top;
    let bottom;

    if (rect instanceof DOMRect) {
        ({ left, right, top, bottom } = rect);
    } else {
        left = rect.x;
        right = left + rect.width;
        top = rect.y;
        bottom = top + rect.height;
    }

    const { x, y } = point;
    const {
        discardHorizontalPosition,
        discardVerticalPosition,
        endsInclusive = true
    } = options;

    const pointInsideHorizontalRange = discardHorizontalPosition ||
        (x >= left && (endsInclusive ? x <= right : x < right));

    const pointInsideVerticalRange = discardVerticalPosition ||
        (y >= top && (endsInclusive ? y <= bottom : y < bottom));

    return pointInsideHorizontalRange && pointInsideVerticalRange;
}

// MDN says: it is safest to rely on only properties left, top, right, and bottom.
function rectanglesIntersect(rect: DOMRect, otherRect: DOMRect): boolean {
    return rect.left < otherRect.right && rect.right > otherRect.left &&
        rect.top < otherRect.bottom && rect.bottom > otherRect.top;
}

function translatePercentagePoint(percentagePoint: Point, rect: Rect, outerRect: Rect): Point {
    const globalX = rect.x + (rect.width * percentagePoint.x);
    const globalY = rect.y + (rect.height * percentagePoint.y);

    return {
        x: (globalX - outerRect.x) / outerRect.width,
        y: (globalY - outerRect.y) / outerRect.height
    };
}

export { rectContains, rectContainsPoint, rectanglesIntersect, translatePercentagePoint };
